import { FileServiceApi } from 'data/api';
import { RsMime } from 'data/mime-type';
import { Catalogue } from 'data/service-spec';

export const config = {
    api: new FileServiceApi(process.env['REACT_APP_DATA_API'] || ''),
    rootPath: process.env['REACT_APP_ROOT_PATH'],
    mime: new RsMime(),
    serviceCatalogue: undefined as unknown as Catalogue
}